import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import newSortBy from "../../../../../utils/newSortBy";
import { ISortBy } from "../../../../../types";
import { getColumns } from "./constants";
import { StatusColorLegend, Table } from "../../../../../components/ui";
import { financialsActions } from "../../../../../reducers/financials";
import { REBILL_STATUS_COLORS } from "./constants";
import { BILLING_API_URLS, BillingAPI } from "../../../../../api/billing";
import { getQueryStringByStringValues } from "../../../../ComplianceSearch/utils";

interface IProps {
  emails: string;
  reportTitleDate: string;
  periodFilter: {
    startDate: string;
    endDate: string;
  };
}

const PassedAccountStartDateTable: React.FC<IProps> = ({
  emails,
  reportTitleDate,
  periodFilter,
}) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector(
    (state) => state.financials.passersStats.passedSubscription
  );
  const columns = getColumns(reportTitleDate);

  const [sortBy, setSortBy] = useState<ISortBy>({
    by: "purchase_date",
    order: false,
  });
  const handleSortBy = (by: string) => newSortBy({ by, sortBy, setSortBy });

  const { isError, error } = useQuery({
    enabled: !!emails || !!(periodFilter.endDate && periodFilter.startDate),
    queryKey: [
      BILLING_API_URLS.passedSubscriptionPurchaseDate,
      emails,
      sortBy,
      periodFilter.startDate,
      periodFilter.endDate,
    ],
    queryFn: async ({ signal }) => {
      const query = new URLSearchParams();
      query.set("sortBy", sortBy.by);
      query.set("order", sortBy.order ? "asc" : "desc");

      query.set("start_date", periodFilter.startDate);
      query.set("end_date", periodFilter.endDate);

      const emailsQuery = getQueryStringByStringValues("emails", emails);
      const requestQuery = query.toString() + `&${emailsQuery}`;

      dispatch(financialsActions.fetchPassedSubscriptionPurchaseDateRequest());
      const response = await BillingAPI.getPassedSubscriptionPurchaseDateRequest(
        requestQuery,
        signal
      );
      dispatch(financialsActions.fetchPassedSubscriptionPurchaseDateSuccess(response.data));
      return response.data;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(financialsActions.fetchPassedSubscriptionPurchaseDateFailed());
    }
  }, [isError, error]);

  return (
    <div>
      <div>
        {!!data.passedSubscriptionPurchaseDate.length && !loading && (
          <StatusColorLegend legend={REBILL_STATUS_COLORS} />
        )}
      </div>
      <Table
        csv_table_name="Passed Account Start Date"
        theadTitle="Passed Account Start Date"
        columns={columns}
        loading={loading}
        data={data.passedSubscriptionPurchaseDate}
        extractKey={(row) => row.id}
        handleSortBy={handleSortBy}
        sortBy={sortBy}
        isDownloadable
        noResultsMessage=""
      />
    </div>
  );
};

export default PassedAccountStartDateTable;
